import React from 'react';

/** Decorative mail scene. It stays a recognizable envelope with no flip that can look like another object. */
export const GoogleMark: React.FC = () => (
  <svg className="login-google-mark" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    <path fill="none" d="M0 0h48v48H0z" />
  </svg>
);

export const MicrosoftMark: React.FC = () => (
  <svg className="login-google-mark" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#F25022" d="M4 4h19v19H4z" />
    <path fill="#7FBA00" d="M25 4h19v19H25z" />
    <path fill="#00A4EF" d="M4 25h19v19H4z" />
    <path fill="#FFB900" d="M25 25h19v19H25z" />
  </svg>
);

export const SsoMark: React.FC = () => (
  <svg className="login-identity-mark" viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm0 3.1A2.9 2.9 0 1 1 9.1 8 2.9 2.9 0 0 1 12 5.1zm0 13.8a7.2 7.2 0 0 1-6-3.2c.04-2 4-3.1 6-3.1s5.96 1.1 6 3.1a7.2 7.2 0 0 1-6 3.2z"
    />
  </svg>
);

export const LoginEmailScene: React.FC = () => (
  <div className="login-mail-scene">
    <div className="login-mail-card">
      <svg className="login-mail-svg" viewBox="0 0 280 200" aria-hidden="true">
        <rect className="login-mail-desk" x="24" y="28" width="232" height="144" rx="18" />
        <g className="login-mail-letter">
          <rect x="86" y="46" width="108" height="78" rx="8" fill="#fff" />
          <path d="M100 66h80M100 82h62M100 98h46" stroke="#c5cbe8" strokeWidth="5" strokeLinecap="round" />
        </g>
        <path className="login-mail-body" d="M58 92h164a6 6 0 0 1 6 6v62a6 6 0 0 1-6 6H58a6 6 0 0 1-6-6v-62a6 6 0 0 1 6-6z" />
        <path className="login-mail-flap" d="M58 98 L140 154 L222 98" />
        <circle className="login-mail-badge" cx="196" cy="58" r="16" />
        <text className="login-mail-at" x="196" y="64" textAnchor="middle">
          @
        </text>
      </svg>
    </div>
  </div>
);
